module.exports = __webpack_public_path__ + "static/media/DO_icon_map.d7986804.svg";